// File: /pages/About/Our_Mission_And_Values.js
/* eslint-disable react/jsx-filename-extension */
import React from 'react';
import Discuss from 'parts/Discuss';
import Button from 'elements/Button';

export default function OurMissionAndValues() {
  return (
    <>

      <section className="hero py-12">
        <div className="container mx-auto px-6 text-center">
          <h1 className="text-5xl font-bold text-theme-blue mb-4">Our Mission & Values</h1>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">We exist to make technology simple, secure, and reliable for growing businesses. Our team is guided by integrity, curiosity, and a commitment to excellent customer outcomes.</p>
        </div>
      </section>

      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-6 grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="p-6 bg-white rounded-2xl shadow-md">
            <h3 className="text-xl font-semibold mb-2">Integrity</h3>
            <p className="text-gray-600">We do what we say and protect client trust with transparent pricing and honest recommendations.</p>
          </div>
          <div className="p-6 bg-white rounded-2xl shadow-md">
            <h3 className="text-xl font-semibold mb-2">Customer Focus</h3>
            <p className="text-gray-600">Your success is our priority — we build solutions that solve real business problems.</p>
          </div>
          <div className="p-6 bg-white rounded-2xl shadow-md">
            <h3 className="text-xl font-semibold mb-2">Continuous Improvement</h3>
            <p className="text-gray-600">We learn, adapt and innovate to keep clients ahead of change.</p>
          </div>
        </div>
      </section>

      <section className="py-12 container mx-auto px-6 text-center">
        <Button href="/contact" type="link" className="px-6 py-3 bg-theme-purple text-white rounded-full">Work With Us</Button>
      </section>

      <Discuss />
    </>
  );
}
